import { timeout } from '@/store/error';

export default {
  namespaced: true,
  state: {
    message: null,
  },
  mutations: {
    setSuccessMessage(state, message) {
      state.message = message;
    },
  },
  actions: {
    setMessage({ commit }, message) {
      commit('setSuccessMessage', message);
      setTimeout(() => {
        commit('setSuccessMessage', null);
      }, timeout(message));
    },
  },
  getters: {
    message: state => state.message,
  },
};
